/* Shipping Protection bubble: adds or removes the protection item from the cart,
   and removes it again if it is the only thing left in the cart. */
(function () {
  'use strict';

  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCartPage = document.body.classList.contains('template-cart');

  function post(url, payload) {
    return fetch(routeRoot + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  async function refresh() {
    if (onCartPage) { window.location.reload(); return; }
    var res = await fetch(routeRoot + '?sections=cart-drawer');
    var html = (await res.json())['cart-drawer'];
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-inner]');
    var current = document.querySelector('[data-cart-drawer-inner]');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    var count = parseInt(fresh.getAttribute('data-cart-count'), 10) || 0;
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
    cleanUp();
  }

  // Protection on its own makes no sense: drop it when the bag has nothing else.
  var cleaning = false;
  async function cleanUp() {
    var flag = document.querySelector('[data-only-protection]');
    if (!flag || cleaning) return;
    cleaning = true;
    await post('cart/change.js', { id: flag.getAttribute('data-only-protection'), quantity: 0 });
    cleaning = false;
    refresh();
  }

  document.addEventListener('change', async function (e) {
    var input = e.target.closest && e.target.closest('[data-ship-protect]');
    if (!input) return;
    var id = input.getAttribute('data-variant-id');
    var label = input.closest('.ship-protect');
    input.disabled = true;
    if (label) label.classList.toggle('is-on', input.checked);
    try {
      if (input.checked) await post('cart/add.js', { id: id, quantity: 1 });
      else await post('cart/change.js', { id: id, quantity: 0 });
      await refresh();
    } finally {
      input.disabled = false;
    }
  });

  // The theme re-renders the drawer after quantity changes; check it each time.
  var panel = document.querySelector('[data-panel="cart"]');
  if (panel && 'MutationObserver' in window) {
    new MutationObserver(function () { cleanUp(); }).observe(panel, { childList: true });
  }
  cleanUp();
})();
